import { React, useState, useEffect, useRef } from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import NotificationPopup from './components/NotificationPopup';
import API from './services/api';
import { initPushNotifications } from './services/pushNotifications';


// Pages
import Accueil from './pages/Accueil';
import Connexion from './pages/Connexion';
import Inscription from './pages/Inscription';
import Annonces from './pages/Annonces';
import DetailAnnonce from './pages/DetailAnnonce';
import CreerAnnonce from './pages/CreerAnnonce';
import MonProfil from './pages/MonProfil';
import ModifierProfil from './pages/ModifierProfil';
import MesAnnonces from './pages/MesAnnonces';
import MesFavoris from './pages/MesFavoris';
import Messages from './pages/Messages';
import ModifierAnnonce from './pages/ModifierAnnonce';
import Admin from './pages/Admin';
import Abonnements from './pages/Abonnements';
import Analytics from './pages/Analytics';
import Vitrine from './pages/Vitrine';
import ProfilPro from './pages/ProfilPro';
import Alertes from './pages/Alertes';
import Locations from './pages/Locations';
import DetailLocation from './pages/DetailLocation';
import CreerLocation from './pages/CreerLocation';
import MesLocations from './pages/MesLocations';
import MesReservations from './pages/MesReservations';
import Verification from './pages/Verification';
import Contact from './pages/Contact'; // ✅ FIX #1
import CGU from './pages/CGU';
import MotDePasseOublie from './pages/MotDePasseOublie';
import ReinitialiserMotDePasse from './pages/ReinitialiserMotDePasse';

function PushBootstrap() {
  const { user } = useAuth();
  const navigate = useNavigate();
  useEffect(() => {
    if (user) initPushNotifications(navigate);
  }, [user, navigate]);
  return null;
}

function App() {
  const [nouvellesNotifs, setNouvellesNotifs] = useState([]);
  const dejaAffichees = useRef(new Set());

  const checkNotifications = async () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) return;
      const res = await API.get('/notifications');
      const nonLues = res.data.notifications.filter(
        n => !n.lu && !dejaAffichees.current.has(n.id)
      );
      if (nonLues.length > 0) {
        const aAfficher = nonLues.slice(0, 3);
        aAfficher.forEach(n => dejaAffichees.current.add(n.id));
        setNouvellesNotifs(prev => [...prev, ...aAfficher]);
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    checkNotifications();
    const interval = setInterval(checkNotifications, 15000);
    return () => clearInterval(interval);
  }, []);

  const handleClose = async (id) => {
    setNouvellesNotifs(prev => prev.filter(n => n.id !== id));
    try {
      await API.put(`/notifications/${id}/lue`);
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <AuthProvider>
      <Router>
        <PushBootstrap />
        <NotificationPopup
          notifications={nouvellesNotifs}
          onClose={handleClose}
        />
        <Routes>
          <Route path="/" element={<Accueil />} />
          <Route path="/connexion" element={<Connexion />} />
          <Route path="/inscription" element={<Inscription />} />
          <Route path="/annonces" element={<Annonces />} />
          <Route path="/annonces/:id" element={<DetailAnnonce />} />
          <Route path="/annonces/:id/modifier" element={<ModifierAnnonce />} />
          <Route path="/creer-annonce" element={<CreerAnnonce />} />
          <Route path="/profil" element={<MonProfil />} />
          <Route path="/profil/modifier" element={<ModifierProfil />} />
          <Route path="/mes-annonces" element={<MesAnnonces />} />
          <Route path="/mes-favoris" element={<MesFavoris />} />
          <Route path="/messages" element={<Messages />} />
          <Route path="/abonnements" element={<Abonnements />} />
          <Route path="/analytics" element={<Analytics />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/vitrine/:id" element={<Vitrine />} />
          <Route path="/profil-pro" element={<ProfilPro />} />
          <Route path="/alertes" element={<Alertes />} />
          <Route path="/locations" element={<Locations />} />
          <Route path="/locations/:id" element={<DetailLocation />} />
          <Route path="/creer-location" element={<CreerLocation />} />
          <Route path="/mes-locations" element={<MesLocations />} />
          <Route path="/mes-reservations" element={<MesReservations />} />
          <Route path="/verification" element={<Verification />} />
          <Route path="/contact" element={<Contact />} /> {/* ✅ FIX #1 */}
          <Route path="/cgu" element={<CGU />} />
          <Route path="/mot-de-passe-oublie" element={<MotDePasseOublie />} />
          <Route path="/reinitialiser-mot-de-passe/:token" element={<ReinitialiserMotDePasse />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
